/**
 * Created by liuyao on 2017/09/27.
 */

import * as types from '@/store/mutation-types'
import cookie from '@/utils/cookie'
// import { getAccessDataAPI } from '@/api'

// import { loginAPI } from '@/api'

import {
	baseUrl
} from '@/config/env'

const state = {
	token: '',
	loginedUser: { },
	loading: false,
	indexCode:"",
	indexName:"",
	loginStatus:false,
	dimensions:[]
}

const mutations = {
	[types.SET_LOGINED_USER](state, payload) {
		state.loginedUser = payload.loginedUser;
	},
	[types.SET_LOADING](state, payload) {
		state.loading = payload.loading;
	},
	[types.SET_TOKEN](state, payload) {
		state.token = payload.token;
	},
	[types.SET_INDEX_NAME](state, payload) {
		state.indexName = payload.indexName;
	},
	[types.SET_INDEX_CODE](state, payload) {
		state.indexCode = payload.indexCode;
	},
	[types.SET_LOGIN_STATUS](state, payload) {
		state.loginStatus = payload.loginStatus;
	},
	[types.SET_DIMENSIONS](state,payload){
		state.dimensions = payload.dimensions;
	}
	
}

const actions = {
	userIsLogin() {
		// loginAPI.isLogin().then((res) => {
		// 	if (res.code == 0) {
		// 		console.log("当前用户已登录.")
		// 	}
		// });
	},
	setDimensions({commit},status){
		commit(types.SET_DIMENSIONS,{dimensions:status})
	},
	setLoading({ commit }, status) {
		commit(types.SET_LOADING, { loading: status })
	},
	setLoginedUser({ commit }, status) {
		commit(types.SET_LOGINED_USER, { loginedUser: status })
	},
	setToken({ commit }, status) {
		commit(types.SET_TOKEN, { token: status })
	},
	userLogout({ commit }, status) {
        cookie.del('token');
		commit(types.SET_TOKEN, { token: '' })
		commit(types.SET_LOGINED_USER, { loginedUser: {} })
	},
	parseToken({ commit }, token) {
		console.log(commit,token)
		commit(types.SET_TOKEN, { token: token.token });
   //    getAccessDataAPI.parseToken({ token: token }).then(res => {
   //    	console.log("parseToken",res)
   //      if (res.code == 0) {
			// commit(types.SET_TOKEN, { token: token });
			// commit(types.SET_LOGINED_USER, { loginedUser: res.data.user });
   //      }
   //    })
	},
	setLoginStatus({ commit },loginStatus ){
		commit(types.SET_LOGIN_STATUS, { loginStatus: loginStatus });
	},
	convertToken({ commit },params){
		let next = params.next;
		// getAccessDataAPI.accessData({ md5: params.md5 }).then(res => {
		// 	console.log("convertToken",res)
		// 	if(res.code == 0){
		// 		cookie.set('token',res.data.token);
		// 		next(params.path || 'economicConfidence');
		// 	}else{
		// 		// next()
		// 		window.location.href = 'https://125.208.29.19:8098/'
		// 	}
		// })
	}
}

export default {
	state, mutations, actions
}


// WEBPACK FOOTER //
// ./src/store/modules/global.js